const NAMED = {
  blue: '#3b82f6', purple: '#8b5cf6', amber: '#f59e0b', cyan: '#06b6d4',
  indigo: '#6366f1', green: '#10b981', red: '#ef4444', teal: '#14b8a6',
  orange: '#f97316', pink: '#ec4899', gray: '#6b7280', grey: '#6b7280',
  yellow: '#eab308', emerald: '#10b981', sky: '#0ea5e9', violet: '#8b5cf6',
  rose: '#f43f5e', lime: '#84cc16', slate: '#64748b', gold: '#D4A017',
};

export const resolveColor = (c) => {
  if (!c) return '#6b7280';
  const t = String(c).trim().toLowerCase();
  if (t.startsWith('#')) return c;
  return NAMED[t] || '#6b7280';
};
